<template>
<div class="calculator">
    <div class="row">
        <div :class="(display_mode==='inline') ? 'col-md-4' : 'col-md-2'">
            <div class="row">
                <div :class="(display_mode==='inline') ? 'col-md-12' : 'col-md-6'" style="margin-top:20px;">
                    <div class="standard-slider">
                        <span :style="(display_mode==='inline') ? '' : 'writing-mode:vertical-rl;float:left;'">
                        Approx Page/Doc Count
                        </span>
                        <el-slider
                                v-model="inputs.y.size"
                                :vertical="(display_mode==='inline') ? false : true"
                                height="350px"
                                style="margin-left:10px;"
                                :show-tooltip="false"
                                :min="0"
                                :max="4"
                                :marks="{
                          0: '100',
                          1: '1K',
                          2: '10K',
                          3: '100K',
                          4: '1M+',
                        }"
                        >
                        </el-slider>
                    </div>
                    <div class="horizontal-override-slider">
                        <span>
                        Approx Page/Doc Count
                        </span>
                        <el-slider
                            v-model="inputs.y.size"
                            :vertical="false"
                            height="350px"
                            style="margin-left:10px;"
                            :show-tooltip="false"
                            :min="0"
                            :max="4"
                            :marks="{
                          0: '100',
                          1: '1K',
                          2: '10K',
                          3: '100K',
                          4: '1M+',
                        }"
                        >
                        </el-slider>
                    </div>
                </div>
            <div :class="(display_mode==='inline') ? 'col-md-12' : 'col-md-6'" style="margin-top:20px;">
                    <span :style="(display_mode==='inline') ? '' : 'writing-mode:vertical-rl;float:left;'">
                        Percent You Are Analyzing
                    </span>
                    <el-slider class="standard-slider"
                        :vertical="(display_mode==='inline') ? false : true"
                        height="350px"
                        v-model="inputs.y.percent"
                        style="margin-left:10px;"></el-slider>
                    <div style="width: 220px" v-html="percentage_text"></div>
                </div>

            </div>
            <div class="row" style="margin-top:20px;">
                <div class="col-md-12" v-if="display_mode!=='inline'">
                    <p>
                        Here goes some descriptive text.
                    </p>
                </div>
            </div>
        </div>
        <div class="col-md-8">
            <div v-if="display_mode!=='inline'">
                <ChartScatter
                        height="350" width="700"
                        :chartData="chartData"
                        :render_info="{
              display_extra: false,
              background_color_scale: (one_number + 2) > 10 ? 10 : (one_number + 2)
            }"
                >
                </ChartScatter>
            </div>
            <div class="row">
                <div class="col-md-6" style="margin-top:20px;">
                        Sites
                        <el-slider
                                v-model="inputs.x.sites"
                                :show-tooltip="false"
                                :min="0"
                                :max="4"
                                :marks="{
            0: '1',
            1: '2-3',
            2: '10',
            3: '100',
            4: '1K+',
          }"
                        >
                        </el-slider>
                </div>
                <div class="col-md-6" style="margin-top:20px;">
                        Systems
                        <el-slider
                                v-model="inputs.x.systems"
                                :show-tooltip="false"
                                :min="0"
                                :max="3"
                                :marks="{
            0: '1',
            1: '2-3',
            2: '10',
            3: '50+',
          }"
                        >
                        </el-slider>
                </div>
                <div class="col-md-6" style="margin-top:20px;">
                    <div>
                        Content Structure
                    </div>
                    <el-select v-model="inputs.x.content_structure" placeholder="Select">
                        <el-option
                                v-for="item in [
              {label:'Focused Semantic',value:0},
              {label:'Pervasive Semantic',value:1},
              {label:'Some Semantic',value:2},
              {label:'Layout-based Legos',value:3},
              {label:'Branding Template',value:4},
              {label:'None',value:5},
          ]"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <div>
                        <em style="margin-top: 5px;color:gray;font-size:smaller">{{structure_text}}</em>
                    </div>
                </div>
                <div class="col-md-6" style="margin-top:20px;">
                    Languages
                    <el-slider
                            v-model="inputs.x.languages"
                            :show-tooltip="false"
                            :min="0"
                            :max="3"
                            :marks="{
            0: '1',
            1: '2-3',
            2: '10',
            3: '100+'
          }"
                    >
                    </el-slider>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4">
            <el-button @click="submit" style="margin-top:20px;width:100%" type="info">Evaluate Immediately</el-button>
        </div>
        <div class="col-md-12">
            <div style="margin-top:20px;">
                <div v-if="show_results" :style="'height:100%;background-color:' + site_type_color + ';padding:20px;'">
                    <span style="text-align:center;color:white;">{{site_type.toUpperCase()}}</span>
                </div>
                <div style="height:100%;margin-bottom:40px;background-color:#eee;">
                    <div class="markdown" style="padding:20px;">
                        <span v-html="show_text"></span>
                    </div>
                    <el-button style="margin-left:20px;margin-bottom:20px;" v-if="show_confirm_button" @click="confirm">Confirm</el-button>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: "SizeCalculator",
    props: ['display_mode'],
    methods: {
    submit() {
      if (this.confirm_text && !this.show_confirm_button) {
        this.show_results = true
        this.show_text = this.confirm_text
        this.show_confirm_button = true
      } else {
        this.site_type_to_show = this.site_type
        this.site_type_color_to_show = this.site_type_color
        this.show_results = true
        this.show_text = this.evaluation_text
        this.show_confirm_button = false
      }
      this.evaluation_color = 'black'
    },
    confirm() {
      this.show_confirm_button = false
      this.show_text = this.evaluation_text
    },
  },
  computed: {
    percentage_text: function() {
      if (this.inputs.y.percent < 50) {
        return '<p><em style="margin-top: 5px;color:gray;font-size:smaller">Just ' + this.inputs.y.percent + '%? Please consider more of the digital presence. Read <a target="__blank" href="https://davidhobbsconsulting.com/articles/whats-your-number-potential-extent-web-change-impact">What\'s Your Number? Go Wider for Higher Impact</a>.</em></p>'
      }
    },
    structure_text: function() {
      let full_text = [
          "A small set of semantic (not just layout-based) content types covers most content",
          "Virtually all content has semantic (not just layout-based) content types and/or components",
          "Some semantic (not just layout-based) content types and/or components covering some content",
          "Each page is built with layout-based building blocks",
          "Site-wide template, but content within is custom",
          "No structure (every page built from ground up)"
      ]
      return full_text[this.inputs.x.content_structure]
    },
    normalized: function() {
      return {
        x: {     // Need to normalize on a scale of 1-10
          sites: this.conversion_arrays.x.sites[this.inputs.x.sites],
          systems: this.conversion_arrays.x.systems[this.inputs.x.systems],
          languages: this.conversion_arrays.x.languages[this.inputs.x.languages],
          content_structure: this.conversion_arrays.x.content_structure[this.inputs.x.content_structure],
        },
        y: { // Need to normalize size to the actual pages
          size:this.conversion_arrays.y.size[this.inputs.y.size],
          percent:this.inputs.y.percent / 100, // just use the raw percent value (down to a true percentage out of 1), since it's already from 1-100
        }
      }
    },
    evaluation_style: function() {
      return "color:'" + this.evaluation_color + "';padding:20px;"
    },
    evaluation_text: function() {
      if (this.one_number < 3) {
        this.site_type = 'focused'
        this.site_type_color = 'darkgreen'
        return '<p>' +
            'Congratulations! You have a <strong style="color:saddlebrown">focused site</strong>. ' +
            'Do everything you can to stay here. Enjoy the deep level of hands-on control you have ' +
            'for a small site that can be focused on responding to user and business needs.</p>' +
            '<p>On the other hand, <strong style="color:saddlebrown">if</strong> you are working on just a part of a larger digital presence, then ' +
            '<strong style="color:saddlebrown">consider retaking this quiz with the organization-wide view</strong>. It may make sense to press for ' +
            'broader changes.</p>' +
            '<p>Next step: <a href="https://davidhobbsconsulting.com/resources/microsite-checklist" target="_blank">watch the video or download the microsite checklist</a> -- one of the easiest ways of losing focus is adding microsites.</p>'
      } else if (this.one_number < 5 && this.x_max_input !== 10) {
        this.site_type = 'medium'
        this.site_type_color = '#FFC300'
        return '<p>' +
            'Careful! You have a <strong style="color:saddlebrown">medium site</strong>. ' +
            '</p>' +
            '<p>' +
            '<strong>At this complexity you may be tempted to approach things the same way you would for smaller sites.</strong> But these approaches start breaking down at this scale.' +
            '</p>' +
            '<p>' +
            'This is the point where spreadsheets, for example, start being ineffective for content planning.' +
            '</p>'
      } else {
        this.site_type_color = '#C70039'
        this.site_type = 'complex'
        let reason = ''
        if (this.x_max_input===10 && this.one_number<5) {
          reason = 'NOTE: The reason for saying the site is complex is because you maxed out sites, symptoms, or languages. Otherwise this would be medium.'
        }
        return '' +
            '<p>' +
            'You are dealing with a <strong style="color:saddlebrown">complex site</strong>. Of course some sites <em>need</em> to be complex, but you should look for ways to simplify.' +
            '</p>' +
            '<p style="font-size:smaller"><em>' +
            reason +
            '</em></p>' +
            '<p>' +
            '<p>' +
            '<div style="border-bottom:1px solid black;padding-bottom:5px;margin-bottom:10px;margin-top:10px;"><em>Content Analysis Implications</em></div>' +
            '<strong>At this level <span style="color:saddlebrown">meaningful analysis is not practical</span> with spreadsheets.</span></strong>' +
            ' See <a target="__blank" href="https://davidhobbsconsulting.com/articles/seer-content-analysis-scalable-engaging-exploratory-and-repeatable">SEER Content Analysis: Scalable, Engaging, Exploratory, and Repeatable</a> and <a  target="__blank"  href="https://chimera.davidhobbsconsulting.com">Content Chimera</a>' +
            '</p>' +
            '<p>' +
            '<div style="border-bottom:1px solid black;padding-bottom:5px;margin-bottom:10px;margin-top:10px;"><em>Digital Transformation Implications</em></div>' +
            'You need a plan beyond a page-by-page, ad hoc transformation. ' +
            ' See <a target="__blank" href="https://davidhobbsconsulting.com/webinars/global-and-distributed-rollouts">Global and Distributed Rollouts</a> and <a  target="__blank" href="https://davidhobbsconsulting.com/webinars/content-dispositions-creative-approaches-for-higher-impact">Content Dispositions: Creative Approaches For Higher Impact Content Transformations</a>' +
            '</p>' +
            '<p>' +
            '<div style="border-bottom:1px solid black;padding-bottom:5px;margin-bottom:10px;margin-top:10px;"><em>Product Management Implications</em></div>' +
            'An ad hoc and informal approach to defining and implementing features works great if a site is focused enough, but it will not work well at this scale.   ' +
            ' See <a  target="__blank"  href="https://davidhobbsconsulting.com/product-management">Product Management for Agile and High Quality Change</a> and <a  target="__blank" href="https://davidhobbsconsulting.com/articles/depth-scales-dynamic-feature-planning">Depth Scales: Dynamic Feature Planning</a>' +
            '</p>' +
            ''
      }
    },
    confirm_text: function () {
      if (this.conversion_arrays.y.size[this.inputs.y.size] >= 100000 && this.x_avg < 3) {
        return 'You sure? Sites this large usually have more complexity.'
      } else if ( this.coordinates.x > 2 * this.coordinates.y) {
        return 'Really? The complexity seems a bit much given the size.'
      } else return null
    },
    x_avg: function () {
      this.x_max_input = this.normalized.x.systems
      if (this.normalized.x.sites > this.x_max_input) this.x_max_input = this.normalized.x.sites
      if (this.normalized.x.languages > this.x_max_input) this.x_max_input = this.normalized.x.languages
      return (this.normalized.x.systems+this.normalized.x.sites+this.normalized.x.languages+this.normalized.x.content_structure)/4
    },
    one_number: function () {
      return (this.coordinates.x + this.coordinates.y) / 2
    },
    coordinates: function () {
      let size = this.normalized.y.size * this.normalized.y.percent
      // Math.log(y)/Math.log(10) gives the base 10 log
      // Since the maximum value is a million (so log = 6) and the minimum is 100 (so log = 2),
      // we then need to get the range from 2 to 6 multiply by 10/4 to get on our scale.
      let y = (Math.log(size)/Math.log(10)-2)*(10/4)
      if (y<1) y = 1
      if (y>10) y = 10

      return {
        x: this.x_avg,
        y: y
      }
    },
    chartData: function() {
      return {
          data: [
            {
              category: 'uncategorized',
              category_actual: '',
              color: 'black',
              label: 'You are here',
              overlaps: false,
              x: this.coordinates.x,
              y: this.coordinates.y,
              size: 10,
              opacity: 1,
              shape: 'x'
            }
          ],
          meta: {
              color_by_field: '',
              label: 'Analysis and Planning Complexity',
              max_x: 10.5,
              max_y: 10.5,
              min_x: 0.5,
              min_y: 0.5,
              x: 'Complexity',
              y: 'Size'
          }
      }
    }
  },
  data() {
    return {
      show_results: false,
      x_max_input: 1,
      show_confirm_button: false,
      show_text: 'Evaluation will appear here after you have set all the values and click the submit button.',
      site_type: '',
      site_type_to_show: '',
      site_type_color: '',
      site_type_color_to_show: '',
      evaluation_color: "gray",
      inputs: { // These are the raw values from the slides and dropdowns
        x: {
          sites: 0,
          systems: 0,
          languages: 0,
          content_structure: 3
        },
        y: {
          size:1,
          percent:75,
        },
      },
      conversion_arrays: {
        x: { // These convert from raw values to 1-10
          sites: [1,3,5,8,10],
          systems: [1,3,6,10],
          languages: [1,3,6,10],
          content_structure: [1,3,5,7,9,10],
        },
        y: {
          size: [100,1000,10000,100000,1000000,10000000],
          percent: [], // percent is just taken direct
        },
      }
    }
  },
}
</script>

<style scoped>

</style>